import { Dialog } from "@mui/material";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";

/**
 * AccessDeniedModal — reusable access denied dialog.
 *
 * Props:
 *   message      {string}   Body text shown to user.
 *   otherApps    {string[]} Optional list of apps user has access to (license case).
 *   onLogout     {fn}       Called when user clicks Logout.
 *   onOk         {fn}       Called when user clicks Ok (redirect to MyBiz).
 *   isLoggingOut {bool}     Disables Logout button during async cleanup.
 */
const AccessDeniedModal = ({ message, otherApps = [], onLogout, onOk, isLoggingOut = false }) => {
  return (
    <Dialog open={true} aria-labelledby="access-denied-modal" maxWidth="sm" fullWidth={true} disableEscapeKeyDown>
      <div style={{ margin: "5%" }}>
        <ModalTitle>
          <Title size="large" bold>
            Access Denied
          </Title>
        </ModalTitle>
        <ModalBody>
          <Body size="large">{message}</Body>
          {otherApps.length > 0 && (
            <div style={{ marginTop: "1rem" }}>
              <Body size="medium">
                You have access to: <strong>{otherApps.join(", ")}</strong>
              </Body>
            </div>
          )}
        </ModalBody>
        <ModalFooter
          buttonData={{
            primary: {
              width: "150px",
              children: "Logout",
              "data-testid": "access-denied-modal-logout-button",
              disabled: isLoggingOut,
              disabled: isLoggingOut,
              onClick: onLogout
            },
            close: {
              children: "Ok",
              width: "150px",
              "data-testid": "access-denied-modal-ok-button",
              onClick: onOk
            }
          }}
        />
      </div>
    </Dialog>
  );
};

export default AccessDeniedModal;
